import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import apiService from '../services/apiService';

const FeatureContext = createContext({});

export const useFeatureContext = () => useContext(FeatureContext);

export const FeatureProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [features, setFeatures] = useState(null); // null = loading

  useEffect(() => {
    // Wait for auth to resolve and a user to be present
    if (authLoading || !user) {
      if (!authLoading && !user) {
        // Auth resolved but no user — fail closed with empty set
        setFeatures({});
      }
      return;
    }

    apiService.get('/api/v1/features', user)
      .then(data => setFeatures(data.features || {}))
      .catch(err => {
        console.error('Failed to load feature flags:', err);
        setFeatures({}); // fail closed
      });
  }, [user, authLoading]);

  return (
    <FeatureContext.Provider value={{ features }}>
      {children}
    </FeatureContext.Provider>
  );
};
